import { render, staticRenderFns } from "./CaseCount.vue?vue&type=template&id=6f462fa2&scoped=true&"
import script from "./CaseCount.vue?vue&type=script&lang=js&"
export * from "./CaseCount.vue?vue&type=script&lang=js&"
import style0 from "./CaseCount.vue?vue&type=style&index=0&id=6f462fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f462fa2",
  null
  
)

export default component.exports